import KunLoading117 from './src/index'

KunLoading117.install = function (Vue) {
	Vue.component(KunLoading117.name, KunLoading117);
}

export default KunLoading117;
